var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtaBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1184,
    height: 472,
    viewBox: "0 0 1184 472",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1183.72-71.914C1181.68 32.6 1154.46 139.938 1075 219.787c-50.6 51.062-115.127 85.897-185.42 100.1 70.297 14.189 134.83 49.026 185.42 100.099 75.81 76.179 106.24 178.512 108.82 277.533 0 4.672.18 9.343.18 13.989v15.964h-45.78c-6.03 0-12.05-.128-18.08-.436-88.47-4.286-177.631-39.912-244.246-106.876-70.573-70.942-106.166-207.078-106.728-300.042v-.36c.562-93.144 36.129-229.074 106.754-300.068 68.121-68.504 159.89-104.18 250.22-107.107h57.58v15.503zM901.095 601.295c0-.256 0 0 0 0z",
    fill: "#0061FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M371.222 720.083c224.443 0 406.389-181.006 406.389-404.281 0-223.274-181.92-404.274-406.389-404.274v808.555z",
    fill: "#0061FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-32 720.083c224.443 0 406.389-181.006 406.389-404.281 0-223.274-181.921-404.274-406.39-404.274v808.555z",
    fill: "#0061FF"
  })));
}
export default SvgCtaBg;